import { makeStyles } from '@mui/styles';
import colors from "../../../common/styles/colors";

export const useAppHeaderOptionsStyles = makeStyles({
  optionContainer: {
    position: 'relative'
  },
  optionContainerHover: {
    '&:hover': {
      backgroundColor: colors.lightGrey2,
      borderRadius: 5
    }
  },
  iconButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    ["@media (max-width: 768px)"]: {
      margin: '0 3px'
    }
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  buttonTitle: {
    fontSize: 14,
    marginLeft: 5,
    color: colors.primary,
    ["@media (max-width: 768px)"]: {
      display: "none"
    }
  },
  activeButtonContainer: {
    '& > svg': {
      fill: colors.black
    }
  },
  disabledButtonTitle: {
    color: colors.lightGrey3
  },
  activeButtonTitle: {
    color: colors.black
  },
  bottomLine: {
    transition: 'all 2s linear',
    position: 'absolute',
    width: '100%',
    top: '105%',
    height: 0,
    border: 0,
    borderRadius: 40,
    borderTop: `3px solid ${colors.orangeColor1}`,
    ["@media (max-width: 768px)"]: {
      top: '100%',
    }
  }
});
